import React from "react";

import CodeInput from "./CodeInput";

import SmartList from "../common/SmartList";
import Input from "./Input";

export default class Containers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editable: props.editable,
      containers: props.containers,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
  }

  _renderContainer(container, index) {
    let { editable, containers } = this.state;
    const hidden = this.props.hidden
    return (
      <div className="form-group row mb-5">
        <div
          className="col-md-6"
          hidden={hidden("containers.identification_number")}
        >
          <Input
            type="text"
            placeholder="Identification Number"
            value={container.identification_number}
            editable={editable}
            onChange={identification_number => {
              containers[index].identification_number = identification_number
              this.props.onUpdated(containers)
            }}
          />
        </div>
      </div>
    );
  }

  render() {
    let { editable, containers } = this.state;

    let itemName = "Container";
    return (
      <SmartList
        minimal
        items={containers}
        itemName={itemName}
        showItemName={true}
        canDelete={editable}
        canAdd={editable}
        renderItem={(containers, index) =>
          this._renderContainer(containers, index)
        }
        renderDelete={(item, index) => (
          <a
            className="btn btn-sm btn-light-danger"
            onClick={() => {
              containers.splice(index, 1);
              this.props.onUpdated(containers);
            }}
          >
            <i className="la la-trash-o fs-3"></i>
            {itemName}
          </a>
        )}
        onUpdated={(items) => {
          containers = items;
          this.props.onUpdated(containers);
        }}
        onAddItemPressed={() => {
          containers.push({});
          this.props.onUpdated(containers);
        }}
      />
    );
  }
}

Containers.defaultProps = {};
